
import Vue from "vue";
import Component from "vue-class-component"; // 导入组件装饰器
import { getAuthorization } from "@/api/common";
import {
  formatDate,
  domainURL,
  // guid,
  // getFileExtendingName,
  // getYearMonthNow,
  // getDateNow
} from "@/api/tools"; //导入相关工具
import { downloadFile } from "@/utils/index";
import { MarketReportApi } from "@/api/marketReportApi"; //导入配套接口API
import {
  QueryForm,
  GetByPageData,
  GetByPageDataDetail,
  GetStsParam,
  UploadClass,
  AddDataDetail,
} from "@/models/marketReport/marketReportData"; //导入配套数据定义Model
// import OSS from "ali-oss";

@Component({
  components: {},
  filters: {
    //过滤器格式化时间
    myFormatDate: function (time) {
      let date = new Date(time);
      return formatDate(date, "yyyy-MM-dd hh:mm:ss");
    },
    //从路径中获取文件名
    getFileName: function (path) {
      var obj = path.lastIndexOf("/");
      return path.substr(obj + 1);
    },
  },
}) // Component装饰器装饰类
export default class LeavingMsg extends Vue {
  // --------------------------------------------------------------数据区--------------------------------------------------------------
  name = "";
  $refs: Vue["$refs"] & {
    upload: any;
  };
  domainUrl = "";
  tableloading = false;
  rangeTime = "";
  // 新增、编辑Dialog
  isCreate = false;
  dialogReportListVisible = false;
  dialogReportListLoading = false;
  //上传相关
  isUpload = false;
  file = {};
  uploadList = [];
  // 文件多选
  multipleSelection = [];
  timestamp: any = new Date().getTime();
  expire: number = 0;
  client: any = null;
  uploadProgress: number = 0;
  alertMsg = "等待上传";
  alertType = "info";
  headersParams = {
    authorization: null,
  };
  // 日期控件配置
  pickerOptions = {
    shortcuts: [
      {
        text: "最近一周",
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
          picker.$emit("pick", [start, end]);
        },
      },
      {
        text: "最近一个月",
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
          picker.$emit("pick", [start, end]);
        },
      },
      {
        text: "最近三个月",
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
          picker.$emit("pick", [start, end]);
        },
      },
    ],
  };
  stsParam: GetStsParam = new GetStsParam();
  ossClient: UploadClass = new UploadClass();
  // 获取接口API
  marketReport: MarketReportApi = new MarketReportApi();
  // 列表数据-查询参数
  queryForm: QueryForm = new QueryForm();
  // 列表数据-查询结果数据格式
  getByPageData: GetByPageData = new GetByPageData();
  //列表数据-查询结果数据格式-数据部分
  getByPageDataDetail: GetByPageDataDetail = new GetByPageDataDetail();
  // 新增-查询结果数据格式-数据部分
  addDataDetail: AddDataDetail = new AddDataDetail();
  totalDownloadCount: number = 0;
  totalUniqueDownloaders: number = 0;

  // --------------------------------------------------------------方法区----------------------------------------------------------------
  // 生命周期钩子
  created() {
    this.onQuery(false);
    this.headersParams.authorization = getAuthorization();
    this.domainUrl = domainURL;
  }
  onSelectionChange(val) {
    this.multipleSelection = val;
  }
  // 批量导出下载记录
  onExportRecord() {
    if (this.multipleSelection.length <= 0) {
      return this.$message({
        showClose: true,
        type: "error",
        message: "请选择需要导出下载记录的文件！",
      });
    }
    let data = {
      reportIdList: this.multipleSelection.map((m) => m.id),
      queryDownLoadType: 0,
    };
    this.marketReport.exportDownloadRecord(data).then((res: any) => {
      // this.$message.success("下载成功!");
      downloadFile(res);
    });
  }
  // 单个导出下载记录
  onSingleExportRecord(id) {
    let data = {
      reportIdList: [id],
      queryDownLoadType: 0,
    };
    this.marketReport.exportDownloadRecord([id]).then((res: any) => {
      // this.$message.success("下载成功!");
      console.log(res);
      downloadFile(res);
    });
  }
  onDownloadCommand(command, row) {
    switch (command) {
      case "lookRecord":
        this.$router.push(`/MarketReport/record/${row.id}/${row.typeName}`);
        break;
      case "exportRecord":
        this.onSingleExportRecord(row.id);
        break;
    }
  }
  // 报告列表数据加载
  onQuery(isFlag: boolean = true) {
    this.tableloading = true;
    this.marketReport
      .getByPage(this.queryForm)
      .then((res: any) => {
        if (res.data) {
          this.getByPageData.tableData = res.data.pageData.data;
          this.getByPageData.total = res.data.pageData.total;
          this.totalDownloadCount = res.data.totalDownloadCount;
          this.totalUniqueDownloaders = res.data.totalUniqueDownloaders;
          if (isFlag) {
            this.$message({
              showClose: true,
              message: "查询成功",
              type: "success",
            });
          }
        } else {
          this.$message({
            showClose: true,
            message: "查询失败",
            type: "error",
          });
        }
        this.tableloading = false;
      })
      .catch((error) => {
        this.tableloading = false;
      });
  }
  // 报告种类新增
  onAdd() {
    this.isCreate = true;
    this.addDataDetail = new AddDataDetail();
    this.uploadList = [];
    this.alertMsg = "等待上传";
    this.alertType = "info";
    this.uploadProgress = 0;
    this.dialogReportListVisible = true;
  }
  // 编辑报告种类
  onEdit(row) {
    this.isCreate = false;
    this.addDataDetail.typeName = row.typeName;
    this.addDataDetail.backPicPath = row.backPicPath;
    this.addDataDetail.sort = row.sort;
    this.addDataDetail.id = row.id;
    this.dialogReportListVisible = true;
  }
  // 配置报告文件
  onFile(row) {
    this.$router.push({
      path: "/MarketReport/file",
      query: { id: row.id, typeName: row.typeName },
    });
  }
  // 重新上传
  radioChang(val) {
    if (val) {
      this.uploadList = [];
      this.alertMsg = "等待上传";
      this.alertType = "info";
      this.uploadProgress = 0;
    }
  }
  // 报告种类提交
  onSaveReportList() {
    if (this.addDataDetail.typeName === "") {
      this.$message.warning("请先输入分类名称");
    } else {
      if (this.addDataDetail.reUploadPic || this.isCreate) {
        if (this.$refs.upload.uploadFiles.length === 0) {
          this.$message.warning("请选择背景图");
        } else {
          this.$refs.upload.submit();
        }
      } else if (!this.addDataDetail.reUploadPic && !this.isCreate) {
        this.subMitType();
      }
    }
  }
  // 提交类型判断
  subMitType() {
    this.dialogReportListLoading = true;
    if (this.isCreate) {
      this.marketReport
        .insertReportType(this.addDataDetail)
        .then((res: any) => {
          if (res.data) {
            this.$message({
              showClose: true,
              message: "新增成功",
              type: "success",
            });
            this.dialogReportListVisible = false;
            this.onQuery(false);
          } else {
            this.$message({
              showClose: true,
              message: "新增失败",
              type: "error",
            });
          }
          this.dialogReportListLoading = false;
        })
        .catch((error) => {
          this.dialogReportListLoading = false;
        });
    } else {
      let formdata = new FormData();
      formdata.append("typeName", this.addDataDetail.typeName);
      formdata.append("reUploadPic", this.addDataDetail.reUploadPic);
      formdata.append("sort", this.addDataDetail.sort);
      formdata.append("id", this.addDataDetail.id);
      this.marketReport
        .updateReportType(formdata)
        .then((res: any) => {
          console.log(res.data);
          if (res.data) {
            this.$message({
              showClose: true,
              message: "保存成功",
              type: "success",
            });
            this.dialogReportListVisible = false;
            this.onQuery(false);
          } else {
            this.$message({
              showClose: true,
              message: "保存失败",
              type: "error",
            });
          }
          this.dialogReportListLoading = false;
        })
        .catch((error) => {
          this.dialogReportListLoading = false;
        });
    }
  }
  handleBefore(file) {
    this.file = file;
  }
  handleExceed(files, fileList) {
    this.$message.warning("当前限制选择 1 个文件，请先删除已选择的文件");
  }
  onSuccess() {
    if (this.isCreate) {
      this.$message({
        showClose: true,
        message: "新增成功",
        type: "success",
      });
    } else {
      this.$message({
        showClose: true,
        message: "保存成功",
        type: "success",
      });
    }
    this.dialogReportListVisible = false;
    this.onQuery(false);
  }
  onError(err) {
    let error = JSON.parse(err.toString().replace("Error:", ""));
    this.$message({
      showClose: true,
      message: error.message,
      type: "error",
    });
  }
  // submitUpload() {
  //   let vm = this;
  //   vm.dialogReportListLoading = true;
  //   return vm
  //     .setUploadParam()
  //     .then(async status => {
  //       if (status === 200) {
  //         // vm.isDisabled = true;
  //         this.multipartUpload(this.file);
  //       }
  //     })
  //     .catch(error => {
  //       this.$message.error("文件上传失败，请重试");
  //       this.dialogReportListLoading = false;
  //       //this.removeAllItems();
  //     });
  //   // this.$refs.upload.submit();
  // }
  // // 开始上传
  // async multipartUpload(param) {
  //   let vm = this;
  //   let ossClient = JSON.parse(sessionStorage.getItem("ossClient"));
  //   const storeAs =
  //     new Date().getFullYear() +
  //     "/" +
  //     getYearMonthNow() +
  //     "/" +
  //     getDateNow() +
  //     "/" +
  //     guid() +
  //     getFileExtendingName(param.name);
  //   vm.client = new OSS(ossClient);
  //   await vm.client
  //     .multipartUpload(storeAs, param, {
  //       progress: async function(percentage, cpt) {
  //         vm.uploadProgress = parseInt(percentage * 100);
  //       }
  //     })
  //     .then(async result => {
  //       // vm.isLoaderVisible = false;
  //       vm.alertMsg = "上传成功！";
  //       vm.dialogReportListLoading = false;
  //       vm.alertType = "success";
  //       console.log("result------------", result);
  //       this.addDataDetail.backPicPath = result.name;
  //       this.subMitType();
  //       //   vm.saveFile.fileName = param.name;
  //       //   vm.saveFile.fileSize = param.size;
  //       //   vm.saveFile.ossFilePath = result.name;
  //       //   vm.addFile(vm.saveFile);
  //     })
  //     .catch(err => {
  //       if (!vm.client.isCancel()) {
  //         vm.alertMsg = "上传失败";
  //         vm.alertType = "error";
  //         vm.uploadProgress = 0;
  //         vm.dialogReportListLoading = false;
  //         //vm.removeAllItems();
  //       }
  //     });
  // }
  // // 取消上传
  // cancelFile() {
  //   this.client.cancel();
  // }
  // // 文件上传之前判断签名是否过期
  // setUploadParam() {
  //   return new Promise((resolve, reject) => {
  //     let now = (this.timestamp = new Date().getTime());
  //     this.expire = Number(sessionStorage.getItem("expire"));
  //     if (this.expire < now + 3) {
  //       this.marketReport.getStsToken(this.stsParam).then(
  //         (res: any) => {
  //           this.ossClient.accessKeyId = res.data.accessKeyId;
  //           this.ossClient.accessKeySecret = res.data.accessKeySecret;
  //           this.ossClient.stsToken = res.data.securityToken;
  //           this.expire = new Date(res.data.expiration).getTime();
  //           sessionStorage.setItem("expire", String(this.expire));
  //           sessionStorage.setItem("ossClient", JSON.stringify(this.ossClient));
  //           resolve(200);
  //         },
  //         () => {
  //           reject(400);
  //         }
  //       );
  //     } else {
  //       resolve(200);
  //     }
  //   });
  // }
  // 报告种类删除
  onDelete(row) {
    this.$confirm("此操作将删除该分类, 是否继续?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    }).then(() => {
      this.tableloading = true;
      this.marketReport
        .deleteReportType({ id: row.id })
        .then((res: any) => {
          this.tableloading = false;
          if (res.data) {
            this.$message({
              message: "删除成功",
              type: "success",
              center: true,
            });
            this.onQuery(false);
          } else {
            this.$message.error("删除失败");
          }
        })
        .catch((error) => {
          this.tableloading = false;
        });
    });
  }
  // 日期选择时分解单个字串为beginCreateTime、endCreateTime
  onPickChange() {
    if (this.rangeTime != null && this.rangeTime.length > 0) {
      this.queryForm.beginTime = this.rangeTime[0];
      this.queryForm.endTime = this.rangeTime[1];
    } else {
      this.queryForm.beginTime = "";
      this.queryForm.endTime = "";
    }
  }
  // 报告列表分页页容量变化事件
  onPageSizeChange(val) {
    this.queryForm.pageSize = val;
    this.queryForm.currentPageIndex = 1;
    this.onQuery(false);
  }
  // 报告列表分页页码变化事件
  onPageIndexChange(val) {
    this.queryForm.currentPageIndex = val;
    this.onQuery(false);
  }
  //格式化日期
  formatDate(time) {
    if (time == "") {
      return "";
    }
    let date = new Date(time);
    return formatDate(date, "yyyy-MM-dd hh:mm:ss");
  }
  onClosed() {
    this.addDataDetail.reUploadPic = false;
  }
}
